import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employee',
  'Employment Status',
  'Employment Type',
  'Location',
  'Manager'
];

const TimeOffPayrollReconciliationReport = () => {
  return (
    <CompositeReport dateFilter='range' filters={filters}>
      <Report
        name={t('reports.PAYROLL_RECONCILIATION_REPORT')}
        url='/reports/payroll_reconciliation'
      >
      </Report>
    </CompositeReport>
  );
};

export default TimeOffPayrollReconciliationReport;
